import React, { useState } from "react";
import Style from "./SecondAimTaxi.module.css";
import BurgerMenuTitle from "../../../Component/BurgerMenuTitle/BurgerMenuTitle";
import Mapir from "mapir-react-component";
import { getTaxiPrice } from "../../../Api/TaxiServices";
import { useHistory } from "react-router-dom";
import { errorToast } from "../../../Toast/Toast";

const Map = Mapir.setToken({
  transformRequest: (url) => {
    return {
      url: url,
      headers: {
        "x-api-key":
          "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImE1ODNiNzIzMWNjNTcxNzg4OGI2NzZkODI1NjNjM2RjNGQyNDJlMGVlZmQ3ZDcyZmYxYTZmN2E5ZDhjNmI3YTNhOWIxOTE1ZTdkOTQ5MDE1In0.eyJhdWQiOiIxNTE2OCIsImp0aSI6ImE1ODNiNzIzMWNjNTcxNzg4OGI2NzZkODI1NjNjM2RjNGQyNDJlMGVlZmQ3ZDcyZmYxYTZmN2E5ZDhjNmI3YTNhOWIxOTE1ZTdkOTQ5MDE1IiwiaWF0IjoxNjg3NjA2MzI2LCJuYmYiOjE2ODc2MDYzMjYsImV4cCI6MTY4OTA3NTEyNiwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.oSSkLtV_ZrBPiOLVVRjgAdbmtIKaA03H4zigvRXvnePLmkPd1oBQA4M4k4a68-JB3HtQmcOiXGSB0g_btjL6eArzq6f5g6tjAi0Hr7UV_AyCZXNDEcD1-ZnswznydpHsAiVNtmHD81PloLw6OV_WfQLqZXkE__jVttwk6Pi_8i7G6xEuenJ5GQxxwsyIBxdGvdXu-S85M0ULxcCWaaq1q-fKL9LfqyzxUz-whl_4SgqQHbxrypvuZ3Gi8zv9TYVy0GQx55Rw0rGXnxouQc-xAuWZFMJZ8xMxTPj-Nj4EYoanBvl4oKAqHANbMi-hZq9G-MBlI6bfLE05uN37XAInCA",
        "Mapir-SDK": "reactjs",
      },
    };
  },
  dragRotate: false,
});

const SecondAimTaxi = (props) => {
  const [center, setCenter] = useState([53.54347, 36.69056]);
  const [zoom, setZoom] = useState([12]);
  const [markerEnd, setMarkerEnd] = useState([]);
  const [saveSecondAimAddress, setSecondSaveAimAddress] = useState([]);
  const [loadingState, setLoadingState] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  let history = useHistory();

  function mapClickHandler(map, e) {
    setCenter([e.lngLat.lng, e.lngLat.lat]);
    setTimeout(() => {
      setZoom([15]);
    }, 1000);

    localStorage.setItem("checkMarker", true);
    reverseFunction(map, e);
  }

  function reverseFunction(map, e) {
    var url = `https://map.ir/reverse/no?lat=${e.lngLat.lat}&lon=${e.lngLat.lng}`;
    fetch(url, {
      headers: {
        "Content-Type": "application/json",
        "x-api-key":
          "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImE1ODNiNzIzMWNjNTcxNzg4OGI2NzZkODI1NjNjM2RjNGQyNDJlMGVlZmQ3ZDcyZmYxYTZmN2E5ZDhjNmI3YTNhOWIxOTE1ZTdkOTQ5MDE1In0.eyJhdWQiOiIxNTE2OCIsImp0aSI6ImE1ODNiNzIzMWNjNTcxNzg4OGI2NzZkODI1NjNjM2RjNGQyNDJlMGVlZmQ3ZDcyZmYxYTZmN2E5ZDhjNmI3YTNhOWIxOTE1ZTdkOTQ5MDE1IiwiaWF0IjoxNjg3NjA2MzI2LCJuYmYiOjE2ODc2MDYzMjYsImV4cCI6MTY4OTA3NTEyNiwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.oSSkLtV_ZrBPiOLVVRjgAdbmtIKaA03H4zigvRXvnePLmkPd1oBQA4M4k4a68-JB3HtQmcOiXGSB0g_btjL6eArzq6f5g6tjAi0Hr7UV_AyCZXNDEcD1-ZnswznydpHsAiVNtmHD81PloLw6OV_WfQLqZXkE__jVttwk6Pi_8i7G6xEuenJ5GQxxwsyIBxdGvdXu-S85M0ULxcCWaaq1q-fKL9LfqyzxUz-whl_4SgqQHbxrypvuZ3Gi8zv9TYVy0GQx55Rw0rGXnxouQc-xAuWZFMJZ8xMxTPj-Nj4EYoanBvl4oKAqHANbMi-hZq9G-MBlI6bfLE05uN37XAInCA",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setSecondSaveAimAddress(data);
      });

    const ending = [];
    ending.push(
      <Mapir.Marker
        coordinates={[e.lngLat.lng, e.lngLat.lat]}
        // anchor="bottom"
        Image={"/Assets/Images/map/marker1.png"}
        key={0}
      />
    );
    setCenter([e.lngLat.lng, e.lngLat.lat]);
    setMarkerEnd(ending);
  }

  let direct = [];
  direct.push(props.location.state.current.geom.coordinates);
  direct.push(props.location.state.firstAim.geom.coordinates);

  let addressText = [];
  addressText.push(props.location.state.current.address_compact);
  addressText.push(props.location.state.firstAim.address_compact);

  //////////////////onclick AimAddress /////////////////
  const onclickSecondAimAddress = () => {
    setLoadingState(true);
    direct.push(saveSecondAimAddress.geom.coordinates);
    addressText.push(saveSecondAimAddress.address_compact);
    setTimeout(() => {
      const info = {
        routes: direct,
      };
      getTaxiPrice(info, (succ, res) => {
        if (res.status === 1) {
          setLoadingState(false);
          history.push({
            pathname: "/request-taxi",
            state: {
              response: res.taxi_price,
              current: props.location.state.current,
              first: props.location.state.firstAim,
              second: saveSecondAimAddress,
              direct: direct,
              addressText: addressText,
            },
          });
        } else {
          errorToast(res.message);
          history.push("/taxireqlist");
        }
      });
    }, 1000);
  };
  const handleCurrentLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          setCenter([longitude, latitude]);
          const array = [];
          array.push(
            <Mapir.Marker
              coordinates={[longitude, latitude]}
              Image={"/Assets/Images/map/marker1.png"}
              key={1}
            />
          );
          setMarkerEnd(array);

          // Add a slight delay to ensure the map updates the center before applying zoom
          setTimeout(() => {
            setZoom([15]); // Zoom in on the user's location
          }, 1500);
        },
        (error) => {
          console.error("Error fetching location:", error);
          alert("در مکان یابی شما مشکلی پیش آمده!");
        }
      );
    } else {
      errorToast("مرورگر شما این قابلیت را پشتیبانی نمی کند!");
    }
  };
  // Search functionality
  const handleSearchChange = (e) => {
    const query = e.target.value.trim();
    setSearchQuery(query);

    if (!query) {
      setSuggestions([]);
      return;
    }

    const payload = {
      $filter: "polygon eq true",
      $select: "poi,city,roads,neighborhood",
      polygon: {
        type: "Polygon",
        coordinates: [
          [
            [53.4949, 36.689295],
            [53.52434, 36.705901],
            [53.567101, 36.708051],
            [53.602236, 36.692963],
            [53.549487, 36.675879],
          ],
        ],
      },
      text: query,
    };

    fetch("https://map.ir/search/v2/autocomplete/", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-api-key":
          "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImE1ODNiNzIzMWNjNTcxNzg4OGI2NzZkODI1NjNjM2RjNGQyNDJlMGVlZmQ3ZDcyZmYxYTZmN2E5ZDhjNmI3YTNhOWIxOTE1ZTdkOTQ5MDE1In0.eyJhdWQiOiIxNTE2OCIsImp0aSI6ImE1ODNiNzIzMWNjNTcxNzg4OGI2NzZkODI1NjNjM2RjNGQyNDJlMGVlZmQ3ZDcyZmYxYTZmN2E5ZDhjNmI3YTNhOWIxOTE1ZTdkOTQ5MDE1IiwiaWF0IjoxNjg3NjA2MzI2LCJuYmYiOjE2ODc2MDYzMjYsImV4cCI6MTY4OTA3NTEyNiwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.oSSkLtV_ZrBPiOLVVRjgAdbmtIKaA03H4zigvRXvnePLmkPd1oBQA4M4k4a68-JB3HtQmcOiXGSB0g_btjL6eArzq6f5g6tjAi0Hr7UV_AyCZXNDEcD1-ZnswznydpHsAiVNtmHD81PloLw6OV_WfQLqZXkE__jVttwk6Pi_8i7G6xEuenJ5GQxxwsyIBxdGvdXu-S85M0ULxcCWaaq1q-fKL9LfqyzxUz-whl_4SgqQHbxrypvuZ3Gi8zv9TYVy0GQx55Rw0rGXnxouQc-xAuWZFMJZ8xMxTPj-Nj4EYoanBvl4oKAqHANbMi-hZq9G-MBlI6bfLE05uN37XAInCA",
      },
      body: JSON.stringify(payload),
    })
      .then((response) => response.json())
      .then((data) => setSuggestions(data.value || []))
      .catch((error) => console.error("Error fetching suggestions:", error));
  };
  const handleSuggestionClick = (suggestion) => {
    setCenter(suggestion.geom.coordinates);
    setZoom([16]);
    setSearchQuery("");
    setSuggestions([]);
  };

  return (
    <div className={Style.container}>
      <BurgerMenuTitle title="تاکسی" />
      <Mapir
        center={center}
        zoom={zoom}
        Map={Map}
        onClick={(map, e) => mapClickHandler(map, e)}
      >
        {markerEnd}
      </Mapir>
      <button className="current-location-btn" onClick={handleCurrentLocation}>
        📍
      </button>

      <div className={Style.bottomPart}>
        <div className={Style.searchContainer}>
          <input
            type="text"
            className={Style.searchInput}
            placeholder="جستجو..."
            value={searchQuery}
            onChange={handleSearchChange}
          />
          {suggestions.length > 0 && (
            <ul className={Style.suggestions}>
              {suggestions.map((item, index) => (
                <li
                  key={index}
                  className={Style.suggestionItem}
                  onClick={() => handleSuggestionClick(item)}
                >
                  {item.title}
                </li>
              ))}
            </ul>
          )}
        </div>
        <div className={Style.aim}>
          <button
            onClick={onclickSecondAimAddress}
            className={Style.setAddress}
            disabled={loadingState}
          >
            {loadingState ? "منتظر باشید..." : "تایید مقصد"}
          </button>
        </div>
      </div>
      {/* <div className={Style.bottomPart}>
        <div className={Style.aim}>
          <button
            onClick={onclickSecondAimAddress}
            className={Style.setAddress}
          >
              تایید مقصد دوم
          </button>
        </div>
      </div> */}
    </div>
  );
};

export default SecondAimTaxi;
